export const handleError = (err, defaultErrorMessage) => {
  let errorMessage;
  if (err.response && err.response.data) {
    errorMessage = err.response.data.message || defaultErrorMessage;
  } else {
    errorMessage = defaultErrorMessage;
  }
  const error = new Error(errorMessage);
  error.status = err?.response?.status;
  return error;
};
